var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Refresh_3344616",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7978",
    "data-name": "Group 7978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M15.328,7.328A.672.672,0,0,0,14.657,8a6.657,6.657,0,1,1-2.784-5.414h-.887a.672.672,0,1,0,0,1.343h2.586a.672.672,0,0,0,.672-.672V.672a.672.672,0,1,0-1.343,0V1.677A8,8,0,1,0,16,8,.672.672,0,0,0,15.328,7.328Z",
    fill: "#203662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.1d636a460e9de7b6844a40d55e240409.svg";
export { ForwardRef as ReactComponent };